module.exports = {
  App: {
    wifi: 'wifi',
    name: '名称',
    number: '编号',
    phone: '手机',
    sms: '短信',
    email: '邮箱',
    id: 'ID',
    done: '完成',
    close: '关闭',
    floor: '楼层',
    company: '公司',
    position: '位置',
    remarks: '备注',
    password: '密码',
    account: '账号',
    delete: '删除',
    no: '否',
    yes:'是',
    bnwk:'不能为空',
    nextStep: '下一步',
    lastStep: '上一步',

    getVerificatioCode: '获取验证码',
    save: '保  存',

    selectTargeting: '选择定位',
    jd: '经度',
    wd: '纬度',

    view:'查看',
    edit:'编辑',
    cancel:'取消',
    exit:'退出',
    ok:'确认',
    signOut:'退出登录',
    pageTitle1: '运动场',
    pageTitle2: '日程设置',
    pageTitle3: '场景设置',
    pageTitle4: '系统设置',
    pageTitle5: '项目设置',
    pageTitle6: '网关设置',
    pageTitle7: '日程设置',
    pageTitle8: '能耗统计',
    
    text1: '登录',

    text8: '超级管理员',
    text9: '项目账号',
    text10: '执行账号',
    text11 : '请输入帐号及密码。',
    text12 : '是否添加场景?',
    text13 : '搜索场景',
    text14 : '引导模式结束,项目设置完成',
    text15 : '请选择项目',
    text16 : '管理账号',
    text17 : '是否进入引导模式',

    login: {
      text1: '欢迎回来!',
      text2: '祝您今日也拥有美好的一天！',
      text3: '请输入您的登录名',
      text4: '请输入您的密码',
      text5: '请输入验证码',
      text6: '登录',
      text7: '忘记密码',
      text8: '记住密码',
      text9: '中文',
      text10: '英文',
    },
    calendar:{
      calendar_text1: '日',
      calendar_text2: '一',
      calendar_text3: '二',
      calendar_text4: '三',
      calendar_text5: '四',
      calendar_text6: '五',
      calendar_text7: '六',
      month1: '1月',
      month2: '2月',
      month3: '3月',
      month4: '4月',
      month5: '5月',
      month6: '6月',
      month7: '7月',
      month8: '8月',
      month9: '9月',
      month10: '10月',
      month11: '11月',
      month12: '12月',

      text1:'执行',
      text2:'上一年',
      text3:'上个月',
      text4:'下个月',
      text5:'下一年',
      text6:'添加日程',

      text7:'日出推迟',
      text8:'日出提前',
      text9:'日落推迟',
      text10:'日落提前',
    },
    systemSetting:{
      text1:'帐户设置',
      text2:'原始帐户',
      text3:'原始密码',
      text4:'账户变更',
      text5:'密码更改',
      text6:'密码确认',
      text7:'或原始身份设置',
      text8:'取消',
      text9:'确定',
      text10:'时区',
      text11:'东八时区',
      text12:'东十时区',
      text13:'主题设置',
      text14:'联系人设置',
      text15:'故障',
      text16:'电话',
      text17:'电子邮件',
      text18:'过温',
      text19:'保质期',
      text20:'取消',
      text21:'确认',
      text22:'默认头像',
      text23:'自定义头像',
      text24:'修改头像',
      text25:'应用',
      text26:'添加场景',
      text27:'调光',
      text28:'控制区',
      text29:'日程表',
      text30:'项目重置',

      text31:'重置引导模式',
      text32:'重置项目信息',
      text33:'备注：不连接外部网络，不能使用本功能',

      ldentity1:'超级账户',
      ldentity2:'项目帐户',
      ldentity3:'项目帐户',
      ldentity4:'经营账户',
    },
    subAccountSetting:{
      text1:'新建账号',
      text2:'账户名称',
      text3:'输入密码',
      text4:'密码确认',
      text5:'账号设置',
      text6:'子账户列表',
      text7:'联系',
      text8:'账号类型',
      text9:'备注',
    },
    sceneSetting:{
      label1:'场景',
      label2:'控制区域',
      label3:'场景名称',

      placeholder1:'场景名称',

      sceneType1:'调光',
      sceneType2:'跑马灯',
      sceneType3:'爆闪',
      sceneType4:'开场',
      sceneType5:'进球',
      sceneType7:'色温',

      duration: '持续时间（秒）',
      interval: '间隔时间（毫秒）',
      sort: '排序',

      btn1:'编辑',
      btn2:'日程表',
      btn3:'删除',
    },
    projectSettings:{
      text1: '项目设置',
      text2: '项目名称',
      text3: '项目地点',
      text4: '项目说明',
      text5: '网关设置',
      text6: '灯控编辑',
    },
    gatewayInput:{
      text1: '序号.',
      text2: '名称',
      text3: 'ID',
      text4: '创建时间',
      text5: '备注',
      text6: 'wifi列表',
      text7: 'wifi名称',
      text8: 'wifi密码',
      text9: '灯控列表',
      text10: '全选',
      text11: '保修期',
      text12: '手动添加',
      text13: '设备SN',
    },
    controllerInput:{
      text1: '序号.',
      text2: '名称',
      text3: 'Id',
      text4: '网关',
      text5: '分组',
      text6: '创建时间',
      text7: '备注',
      text8: '正常',
      text9: '告警',
      text10: '网络状态',
      text11: '告警状态',
    },
    groupSetting:{
      text1: '序号.',
      text2: '分组',
      text3: 'ID',
      text4: '备注',
      text5: '未选中灯控',
      text6: '有分组未选中灯控',
      text7: '分组名称',
      text8: '灯控',
      text9: '添加灯控',
    },
    schedule:{
      text1: '设置可选',
      text2: '特定时间',
      text3: '日出时间',
      text4: '开始时间',
      text5: '结束时间',
      text6: '开始日期',
      text7: '结束日期',
      text8: '星期',
      text9: '日程表',
      text10: '选择场景',

      label1:'日出偏移时间',
      label2:'日落偏移时间',
      label3:'从选定的日出时间开始',
      label4:'从选定的日落时间开始',

      timeUnit0:'分钟',
      timeUnit1:'小时',

      day0:'S',
      day1:'M',
      day2:'T',
      day3:'W',
      day4:'T',
      day5:'F',
      day6:'S',

    },
    home:{
      text1:'概览',
      text2:'支持iec',
      text3:'在线',
      text4:'故障',
      text5:'离线',
      text6:'过温',
      text7:'首页',
      text8:'场景设置',
      text9:'日程设置',
      text10:'系统设置',
      text11:'能耗统计',
      text12:'场景',
      text13:'分组',
      text14:'全部灯控',
      text15:'分组',
      text16:'亮度',
      text17:'名称',
      text18:'ID',
      text19:'分组',
      text20:'网关',
      text21:'场景',
      text22:'亮度',
      text23:'状态',
      text24:'电力',
      text25:'Curent',
      text26:'电压',
      text27:'在线的',
      text28:'选定的灯控',
      text29:'应用',
      text30:'场景',

      nav_btn1:'设备设置',
      nav_btn2:'分组设置',
      nav_btn3:'网关设置',
      
      btn_text1:'+新建项目',
      

      text:'所选灯控：',

      alarmStatus0:'正常的',
      alarmStatus1:'警报',

      lightOnline0:'离线',
      lightOnline1:'在线',

      text31: '网关描述',
      text32: '组网',
      text33: '搜索灯控',
      text34: '项目ID',
      text35: '	x坐标信息',
      text36: '	y坐标信息',
      text37: '	过期时间',
      text38: '	更新时间',
      text39: 'TEMP(驱动器)',
      text40: '温度（控制器）',
      text41: '色温',
    },
    
    
    placeholder: {
      text1: '搜索用户名',
      text2: '搜索日志说明',
      text3: '搜索名称',
      text4: '请输入关键字搜索',
    },
    sideBar: {
      text1: '概览',
      text2: '房间',
      text3: 'LED灯',
      text4: '线条灯',
      text5: '开关面板',
      text6: '窗帘',
      text7: '普通灯',
      text8: 'HCL灯',
      text15: '传感器',
      text9: '空气净化器',
      text10: '网关',
      text11: '告警维修',
      text12: '操作日志',
      text13: '用户管理',
      text14: '酒店管理',
      text16: '单位',
      text17: '单位管理',
      text18: 'UV灯',

      text19: '项目区域',
      text20: '空气质量检测',
      text21: 'triliros管道杀菌器',
      text22: '项目管理',
      text23: '分组',
      text24: '设备',
    },
    room: {
      text26: '删除',
    },
    retrievePassword: {
      text1: '忘记密码',
      text2: '用户名',
      text3: '验证码',
      text4: '*为了您的帐户安全，您将收到一个安全密码更改链接到您的电子邮件。收到电子邮件后，即可更改您的密码。',
      text5: '新密码:',
      text6: '邮箱验证码:',
      text7: '发送',
    },
    mian_sidebar: {
      accountName: '账户名',//
      userNav1: '基本信息',//
      userNav2: '修改密码',//
      mailbox: '邮箱',//
      verificationCode: '验证码',//
      newPassword: '新密码',//
      confirmPassword: '确认密码',//

    },
    grouping: {
      text1: '分组列表'
    },
    message: {
      imgType: '上传图片只能是 png 或者 jpeg 格式！',
      text1: '系统提示',
      text2: '确认',
      text3: '是否确认删除?',
      text4: '提示',
      text5: '确定',
      text6: '取消',
      text7: '已取消删除',
      text8: '不能升级',
      text9: '设备不在线',
      text10: '是最新版本',
      text11: '请选择设备',
      text12: '灯:',
      text13: '不在线',
      text14: '没有网关绑定',
      text15: '设备未绑定到网关',
      text16: '您确定要删除设备吗?',
      text17: '警告',
      text18: '已取消删除',
      text19: 'HCL灯名称：',
      text20: '传感器名称:',
      text21: '空气净化器名称:',
      text22: '设备名称:',
      text23: '未选中',
      text24: '是否确认删除网关?',
      text25: '您确定要删除该服务吗？',
      text26: '您确定要标记并处理当前故障吗？',
      text27: '您确定要删除警报配置文件吗？',
      text28: '您确定要删除维修人员吗？',
      text29: '仅以JPG，PNG格式上传图片！',
      text30: '上传图片的大小不能超过2MB！',
      text31: '您确定要删除该用户吗？',
      text32: '您确定要删除房间吗？',
      text33: '您确定要删除该建筑吗？',
      text34: '您确定要删除该楼层吗？',
      text35: '您确定要删除该酒店吗？',
      text36: '您确定要删除该计划吗？',
      text37: '睡眠时间应该比起床时间晚4个小时',
      text38: '请等待上一个操作返回',
      text39: '是否确认取消故障？',
      text40: '确定要清空工作时间吗?',
      text41: '是否确定退出登录',
      delDevText: '是否确认从数据库删除设备?',
      text42: '请选择场景',

      text43: '是否确认重置?',
      text44: '已取消重置',

      text45: '请输入正确的经纬度',
      text46: '已取消重置',
      text47: '已取消重置',
      text48: '请先添加项目',

      text49: '已取消登录',
      text50: '该帐号已登录在线，确认让对方下线继续登录?',
      text51: '您的账号已在别处登录',
      text52: '已取消登录',
      text53: '登录成功',
      text54: '请先添加网关',

    },
    powerConsumption: {
      text1: '天',
      text2: '周',
      text3: '月',
      text4: '年',
      // text5: '确定',
    },
    status: {
      text0: '系统设置',
      text1: '项目设置',
      text2: '设备设置',
      text3: '分组设置',
      text4: '情景设置',
      text5: '日程设置',
      text6: '未设置过',
      text7: '已设置过',
    }
  }
}